import Header from "../../Header";
import tableStyle from "../../General CSS/Table.module.css";
import React, {useEffect, useState} from "react";
import {Rota as RotaInterface} from "../../Types/Rota";
import {deleteRotaEntry, getRota, randomiseRota} from "../../API/RotaManager";
import {getMe} from "../../Auth/Tokens";
import {Housemate} from "../../Types/Housemate";

export default function Rota() {
    const [rota, setRota] = useState<RotaInterface[] | null>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [me, setMe] = useState<Housemate | null>(null);
    const [selectedDate, setSelectedDate] = useState<Date>(new Date());

    useEffect(() => {
        Promise.all([getRota(new Date()), getMe()])
            .then(([rotaData, meData]) => {
                setRota(rotaData);
                setMe(meData);
            })
            .catch(err => setError(err.message || "Unknown Error"))
            .finally(() => setLoading(false));
    }, []);

    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const userSelectedDate = new Date(event.target.value);
        setSelectedDate(userSelectedDate);
        setLoading(true);
        getRota(userSelectedDate)
            .then((data: RotaInterface[] | null) => setRota(data))
            .catch(err => setError(err.message || "Unknown Error"))
            .finally(() => setLoading(false));
    }

    const handleRandomiseRota = async () => {
        if (window.confirm("Are you sure you want to randomise the rota?")) {
            setLoading(true);

            await randomiseRota(selectedDate)
                .catch(err => setError(err.message || "Unknown Error"));

            getRota(selectedDate)
                .then((data: RotaInterface[] | null) => setRota(data))
                .finally(() => setLoading(false));
        }
    }

    const handleDeleteRotaEntry = async (id: number) => {
        if (window.confirm("Are you sure you want to delete this rota entry?")) {
            setLoading(true);

            await deleteRotaEntry(id)
                .then(() => {
                    setRota((prev: RotaInterface[] | null | undefined) => {
                        if (!prev) return prev;
                        return prev.filter(rota => rota.id !== id);
                    });
                })
                .catch(err => setError(err.message || "Unknown Error"))
                .finally(() => setLoading(false));
        }
    }

    return (
        <>
            <Header page={"Rota"} returnLink={"/"} />
            <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100px",
                width: "100%",
                marginTop: "20px",
                gap: "20px",
            }}>
            <input type="date" id="date" name="date"
                   defaultValue={new Date().toISOString().split("T")[0]}
                   onChange={handleDateChange}
                   style={{
                       width: "200px",
                       height: "40px",
                       padding: "10px",
                       borderRadius: "5px",
                       border: "1px solid #ccc",
                       fontSize: "16px",
                   }}
            />
            </div>

            { rota ? (
                <div className={tableStyle.table}>
                    <table>
                        <thead>
                        <tr>
                            <th>Date</th>
                            <th>Individual</th>
                            <th>Job Details</th>
                        </tr>
                        </thead>
                        <tbody>
                        {rota.sort((a, b) => a.date.getTime() - b.date.getTime())
                            .map((rota: RotaInterface) => (
                        <tr key={rota.id}>
                            <td>{rota.date.toLocaleDateString("en-GB", {
                                    weekday: "long",
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                }
                            )}</td>
                            <td>{rota.housemate.name}</td>
                            <td onClick={
                                me?.email === "goldbinkie@gmail.com"
                                    ? () => handleDeleteRotaEntry(rota.id)
                                    : undefined}>{rota.job.name}</td>
                        </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                ) : loading ? (
                    <div className="blank-page"><p>Loading...</p></div>
                ) : <div className="blank-page"><p>No Rota For Specified Time Period</p></div>}
            <div className={tableStyle.table}>
             { me?.email === "goldbinkie@gmail.com" ? (<button onClick={handleRandomiseRota}>Randomise Rota</button>) : "" }
            </div>
        </>
    )
}